import { get, put, patch, post } from "../ApiDecorator"; // 倒入 api
/* 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 * 此处的数据依然来自 Easy Mock
 */

// 单独倒出
const My = {
  //查询用户信息
  userInfo(data) {
    return get("/auth/user/info", data);
  },
  //修改密码
  getChange_pwd(data) {
    return put("/auth/user/change_pwd", data);
  },
  // 修改个人信息（后端对接文档：PUT /auth/user/update_info）
  getfixinfo(data) {
    return put("/auth/user/update_info", data);
  },
  getTitle(data) {
    return get("/auth/user/query_title", data);
  },
  getSubject(data) {
    return get("/auth/user/query_subject", data);
  },
  // 按学校查班级（含 enterYear；本期无 stage）
  queryClazz(data) {
    return get("/auth/user/query_clazz", data);
  },
  // 地区树懒加载
  queryRegions(data) {
    return get("/auth/user/query_regions", data);
  },
  // 按地区查学校，列表取 data.school
  querySchool(data) {
    return get("/auth/user/query_school", data);
  },
  // 姓名/手机查重
  checkUserExist(data) {
    return get("/auth/user/check_exist", data);
  },
  // 获取荣誉列表
  getAwardList(data) {
    return get("/auth/project/getUserAward",data)
  }
};

// 默认全部倒出
export default My;
